/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSpendRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetSpendRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetSpendRuleSecurity = {
  option1?: GetSpendRuleSecurityOption1 | undefined;
  option2?: GetSpendRuleSecurityOption2 | undefined;
};

export type GetSpendRuleRequest = {
  /**
   * The rule ID.
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSpendRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetSpendRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  GetSpendRuleSecurityOption1$Outbound,
  GetSpendRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getSpendRuleSecurityOption1ToJSON(
  getSpendRuleSecurityOption1: GetSpendRuleSecurityOption1,
): string {
  return JSON.stringify(
    GetSpendRuleSecurityOption1$outboundSchema.parse(
      getSpendRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type GetSpendRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetSpendRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  GetSpendRuleSecurityOption2$Outbound,
  GetSpendRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSpendRuleSecurityOption2ToJSON(
  getSpendRuleSecurityOption2: GetSpendRuleSecurityOption2,
): string {
  return JSON.stringify(
    GetSpendRuleSecurityOption2$outboundSchema.parse(
      getSpendRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type GetSpendRuleSecurity$Outbound = {
  Option1?: GetSpendRuleSecurityOption1$Outbound | undefined;
  Option2?: GetSpendRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetSpendRuleSecurity$outboundSchema: z.ZodMiniType<
  GetSpendRuleSecurity$Outbound,
  GetSpendRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetSpendRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetSpendRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getSpendRuleSecurityToJSON(
  getSpendRuleSecurity: GetSpendRuleSecurity,
): string {
  return JSON.stringify(
    GetSpendRuleSecurity$outboundSchema.parse(getSpendRuleSecurity),
  );
}

/** @internal */
export type GetSpendRuleRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSpendRuleRequest$outboundSchema: z.ZodMiniType<
  GetSpendRuleRequest$Outbound,
  GetSpendRuleRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSpendRuleRequestToJSON(
  getSpendRuleRequest: GetSpendRuleRequest,
): string {
  return JSON.stringify(
    GetSpendRuleRequest$outboundSchema.parse(getSpendRuleRequest),
  );
}
